import cx from "classnames";
import React from "react";
import Icon from '../../common/components/Icon/Icon';
import { IApplicantInfo } from "../interfaces/IAppFormData";

interface ISideBarApplicantRowDetails {
    currentClientNumber: number,
    applicant: IApplicantInfo,
}

const AFSidebarApplicantRow: React.FC<ISideBarApplicantRowDetails> = (props) => {
    const {currentClientNumber, applicant} = props;
    const name = applicant.firstName ?? "Applicant" + applicant.clientNumber.toString();

    return (
        <div className={cx("panel-sidebar-level-2",
            {
                "panel-sidebar-active": currentClientNumber === applicant.clientNumber
            })}>
            <Icon
                alt={currentClientNumber > applicant.clientNumber ? "Tick" : "Pencil"}
                className="space-s"
                size="xl"
                id={currentClientNumber > applicant.clientNumber ? "GreenTickNew" : "Pencil"}
            />
            <span className={cx("text-small")}><strong>{name}</strong></span>
        </div>
    );
};

export default AFSidebarApplicantRow;
